import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template"]

  add(event) {
    event.preventDefault()
    
    // Replace NEW_RECORD placeholder with unique timestamp
    let content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime().toString())
    this.containerTarget.insertAdjacentHTML("beforeend", content)
  }

  remove(event) {
    event.preventDefault()
    
    let wrapper = event.target.closest(".nested-form-wrapper")
    if (wrapper.dataset.newRecord === "true") {
      wrapper.remove()
    } else {
      // For existing records, set _destroy value to "1" and hide the element
      const destroyInput = wrapper.querySelector("input[name*='[_destroy]']")
      if (destroyInput) {
        destroyInput.value = "1"
      }
      wrapper.style.display = "none"
    }
  }
}
